const listProducts = (action /* prevState, nextState */) => {
  const impressions = action.payload.products.map((product, index) => {
    const variant = product.variants && product.variants[0];
    const impression = {
      name: product.title, // Name or ID is required.
      id: (variant && variant.sku) || product.id,
      price: variant && variant.addToCartPrice / 100,
      // brand: 'Google',
      category: action.payload.collection.title,
      variant: variant && variant.title,
      list: action.payload.collection.title,
      position: index + 1
    };
    return impression;
  });

  return {
    event: 'productImpression',
    modifier: 'productList',
    ecommerce: {
      impressions
    }
  };
};

const productClick = (action /* prevState, nextState */) => {
  const { product } = action.payload;
  const variant = product.variants && product.variants[0];
  const impression = {
    name: product.title, // Name or ID is required.
    id: (variant && variant.sku) || product.id,
    price: variant && variant.addToCartPrice / 100,
    // brand: 'Google',
    // category: action.payload.collection.title,
    variant: variant && variant.title
    // position: index + 1
  };
  return {
    event: 'productClick',
    ecommerce: {
      click: {
        // actionField: { list: 'Search Results' }, // Optional list property.
        products: [impression]
      }
    }
  };
};

const getProduct = (action /* prevState, nextState */) => {
  const product = action.payload;
  const variant = product.variants && product.variants[0];
  const impression = {
    name: product.title, // Name or ID is required.
    id: (variant && variant.sku) || product.id,
    price: variant && variant.addToCartPrice / 100,
    // brand: 'Google',
    // category: action.payload.collection.title,
    variant: variant && variant.title
    // list: action.payload.collection.title,
    // position: index + 1
  };
  return {
    event: 'productImpression',
    modifier: 'productDetail',
    ecommerce: {
      detail: {
        // actionField: { list: 'Apparel Gallery' }, // 'detail' actions have an optional list property.
        products: [impression]
      }
    }
  };
};

const addToCart = (action) => {
  const { item, cart } = action.payload;
  const cartItem = cart.items.find((i) => i.sku === item.sku);
  const impression = {
    //  adding a product to a shopping cart.
    name: cartItem.productTitle,
    id: item.sku,
    price: cartItem.price / 100,
    // brand: 'Google',
    // category: 'Apparel',
    variant: cartItem.productVariantTitle,
    quantity: item.quantity
  };
  return {
    event: 'addToCart',
    ecommerce: {
      // currencyCode: 'EUR',
      add: {
        // 'add' actionFieldObject measures.
        products: [impression]
      }
    }
  };
};

const removeFromCart = (action, prevState) => {
  const { sku } = action.payload;
  const cartItem = prevState.cart.data.items.find((i) => i.sku === sku);
  const impression = {
    //  adding a product to a shopping cart.
    name: cartItem.productTitle,
    id: sku,
    price: cartItem.price / 100,
    // brand: 'Google',
    // category: 'Apparel',
    variant: cartItem.productVariantTitle,
    quantity: cartItem.quantity
  };
  return {
    event: 'removeFromCart',
    ecommerce: {
      remove: {
        // 'remove' actionFieldObject measures.
        products: [impression]
      }
    }
  };
};

const addCouponToCart = (action) => {
  const { code, cart } = action.payload;
  const coupon = cart.coupons.find((i) => i.code === code);
  if (!coupon) {
    return null;
  }
  return {
    event: 'promotionClick',
    ecommerce: {
      promoClick: {
        promotions: [
          {
            id: coupon.code, // Name or ID is required.
            name: coupon.title
            // creative: promoObj.creative,
            // position: promoObj.pos
          }
        ]
      }
    }
  };
};

const checkoutStep = (action, prevState) => {
  const cart = prevState.cart.data;
  const { step } = action.payload;
  let stepCount = 0;
  switch (step) {
    case 'customer':
      stepCount = 1;
      break;
    case 'shipping':
      stepCount = 2;
      break;
    case 'payment':
      stepCount = 3;
      break;
    case 'complete':
      stepCount = 4;
      break;
    default:
  }
  const products = cart.items.map((item) => {
    const product = {
      //  adding a product to a shopping cart.
      name: item.productTitle,
      id: item.sku,
      price: item.price / 100,
      // brand: 'Google',
      // category: 'Apparel',
      variant: item.productVariantTitle,
      quantity: item.quantity
    };
    return product;
  });
  let promosOrCoupons = [...cart.promotions, ...cart.coupons];
  promosOrCoupons = promosOrCoupons.filter((promo) => promo.inUse === true);
  const promotions = promosOrCoupons.map((promo) => {
    const promotion = {
      //  adding a product to a shopping cart.
      title: promo.title,
      code: promo.code,
      value: promo.totalValue / 100
    };
    return promotion;
  });
  return {
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: stepCount, option: step },
        products,
        promotions
      }
    }
  };
};

const recordPurchase = (action) => {
  const cart = action.payload;
  const products = cart.items.map((item) => {
    const product = {
      //  adding a product to a shopping cart.
      name: item.productTitle,
      id: item.sku,
      price: item.price / 100,
      // brand: 'Google',
      // category: 'Apparel',
      variant: item.productVariantTitle,
      quantity: item.quantity
    };
    return product;
  });
  let promosOrCoupons = [...cart.promotions, ...cart.coupons];
  promosOrCoupons = promosOrCoupons.filter((promo) => promo.inUse === true);
  const promotions = promosOrCoupons.map((promo) => {
    const promotion = {
      //  adding a product to a shopping cart.
      title: promo.title,
      code: promo.code,
      value: promo.totalValue / 100
    };
    return promotion;
  });
  return {
    event: 'purchase',
    ecommerce: {
      purchase: {
        actionField: {
          id: cart.orderNumber, // Transaction ID. Required for purchases and refunds.
          // affiliation: 'Online Store',
          revenue: cart.total / 100, // Total transaction value (incl. tax and shipping)
          tax: cart.taxTotal / 100,
          shipping: cart.shipTotal / 100
          // coupon: 'SUMMER_SALE'
        },
        products,
        promotions
      }
    }
  };
};

const listReservations = (action /* prevState, nextState */) => {
  const impressions = action.payload.map((reservationType, index) => {
    const variant = reservationType.options && reservationType.options[0];
    const impression = {
      name: reservationType.title, // Name or ID is required.
      id: (variant && variant.sku) || reservationType.id,
      price: variant && variant.price / 100,
      position: index + 1
    };
    return impression;
  });
  let modifier = 'availabilityList';
  if (action.viewType === 'Widget') {
    modifier = 'widget';
  }

  return {
    event: 'reservationImpression',
    modifier,
    reservation: {
      impressions
    }
  };
};

const reservationClick = (action /* prevState, nextState */) => {
  const { payload } = action;
  return {
    event: 'reservationClick',
    reservation: {
      click: {
        name: payload.reservationType,
        id: payload.sku,
        price: payload.price / 100,
        noOfGuests: payload.noOfGuests,
        date: payload.date
      }
    }
  };
};

const reservationCheckoutStep = (action, prevState) => {
  const reservationCart = prevState.reservationCart.data;
  const { step } = action.payload;
  let stepCount = 0;
  switch (step) {
    case 'customer':
      stepCount = 1;
      break;
    case 'payment':
      stepCount = 2;
      break;
    case 'complete':
      stepCount = 3;
      break;
    default:
  }
  return {
    event: 'reservationCheckout',
    reservation: {
      checkout: {
        actionField: { step: stepCount, option: step },
        reservation: {
          name: reservationCart.reservationType.title,
          id: reservationCart.reservationTypeOption.sku,
          price: reservationCart.reservationTypeOption.price / 100,
          noOfGuests: reservationCart.guestCount,
          date: reservationCart.reservationDate
        }
      }
    }
  };
};

const recordReservationPurchase = (action) => {
  const reservation = action.payload;
  return {
    event: 'reservationPurchase',
    reservation: {
      checkout: {
        actionField: {
          id: reservation.reservationNumber, // Transaction ID. Required for purchases and refunds.
          // affiliation: 'Online Store',
          revenue:
            (reservation.guestCount * reservation.reservationTypeOption.price) /
            100 // Total transaction value (incl. tax and shipping)
        },
        reservation: {
          name: reservation.reservationType.title,
          id: reservation.reservationTypeOption.sku,
          price: reservation.reservationTypeOption.price / 100,
          noOfGuests: reservation.guestCount,
          date: reservation.reservationDate
        }
      }
    }
  };
};

const listClubs = (action /* prevState, nextState */) => {
  const impressions = action.payload.clubs.map((club, index) => {
    const impression = {
      name: club.title, // Name or ID is required.
      id: club.slug,
      position: index + 1
    };
    return impression;
  });
  let modifier = 'clubList';
  if (action.viewType === 'joinButton') {
    modifier = 'joinButton';
  }
  return {
    event: 'clubImpression',
    modifier,
    club: {
      impressions
    }
  };
};

const clubClick = (action /* prevState, nextState */) => {
  const { payload } = action;
  return {
    event: 'clubClick',
    club: {
      click: {
        name: payload.title,
        id: payload.slug
      }
    }
  };
};

const clubSignupStep = (action, prevState) => {
  // const clubSignup = prevState.clubSignup.data;
  const { club } = prevState.clubSignup.data;
  const { step } = action.payload;
  let stepCount = 0;
  switch (step) {
    case 'customer':
      stepCount = 1;
      break;
    case 'payment':
      stepCount = 2;
      break;
    case 'account':
      stepCount = 4;
      break;
    case 'complete':
      stepCount = 4;
      break;
    default:
  }
  return {
    event: 'clubCheckout',
    club: {
      checkout: {
        actionField: { step: stepCount, option: step },
        club: {
          name: club.title,
          id: club.slug
        }
      }
    }
  };
};

const recordClubSignup = (action) => {
  const clubMembership = action.payload;
  return {
    event: 'clubJoin',
    club: {
      checkout: {
        actionField: {
          id: clubMembership.id // Transaction ID. Required for purchases and refunds.
          // affiliation: 'Online Store',
        },
        club: {
          name: clubMembership.club.title,
          id: clubMembership.club.slug
        }
      }
    }
  };
};

export const eventsMap = {
  LIST_CLUBS_SUCCESS_GTM: listClubs,
  CLUB_CLICK_SUCCESS_GTM: clubClick,
  CLUB_SIGNUP_STEP_REQUEST_GTM: clubSignupStep,
  CHARGE_CLUB_SIGNUP_SUCCESS_GTM: recordClubSignup,

  LIST_RESERVATION_AVAILABILITIES_SUCCESS_GTM: listReservations,
  RESERVATION_CLICK_SUCCESS_GTM: reservationClick,
  RESERVATION_CHECKOUT_STEP_REQUEST_GTM: reservationCheckoutStep,
  CHARGE_RESERVATION_CART_SUCCESS_GTM: recordReservationPurchase,

  LIST_PRODUCTS_SUCCESS_GTM: listProducts,
  PRODUCT_CLICK_SUCCESS_GTM: productClick,
  GET_PRODUCT_SUCCESS_GTM: getProduct,
  ADD_CART_ITEM_SUCCESS_GTM: addToCart,
  REMOVE_CART_ITEM_SUCCESS_GTM: removeFromCart,
  ADD_COUPON_OR_GIFTCARD_SUCCESS_GTM: addCouponToCart,
  CHARGE_CART_SUCCESS_GTM: recordPurchase,
  CHECKOUT_STEP_REQUEST_GTM: checkoutStep
};
